import Preferences from '@/views/preferences/preferencesPage.vue'

export default [
  {
    path: '/preferences',
    name: 'Dashboard Preferences',
    component: Preferences,
    props: { icon: 'mdi-view-dashboard' },
    meta: {
      title: 'Dashboard Preferences',
      requiresAuth: true,
      authorizedUsers: [7],
    },
  },
]
